import { render, staticRenderFns } from "./step_2.vue?vue&type=template&id=713a1cdd&scoped=true&lang=pug&"
import script from "./step_2.vue?vue&type=script&lang=js&"
export * from "./step_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713a1cdd",
  null
  
)

export default component.exports